"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = (0, tslib_1.__importStar)(require("react"));
var LightboxInfoIcon = function (_a) {
    var size = _a.size, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (React.createElement("svg", (0, tslib_1.__assign)({ viewBox: "0 0 24 24", fill: "currentColor", width: size || '24', height: size || '24' }, props),
        React.createElement("g", { fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(11.111 7.556)" },
                React.createElement("path", { d: "M0 2.91h1.673v4.247l.509.025V8H0v-.785l.197-.018a.41.41 0 0 0 .373-.409c.007-.03.007-.96 0-2.787-.002-.157-.07-.236-.208-.236a13.773 13.773 0 0 0-.362 0v-.856z" }),
                React.createElement("circle", { cx: ".909", cy: ".909", r: "1" })),
            React.createElement("path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-.889A7.111 7.111 0 1 1 12 4.89a7.111 7.111 0 0 1 0 14.222z", fillRule: "nonzero" }))));
};
LightboxInfoIcon.displayName = 'LightboxInfoIcon';
exports.default = LightboxInfoIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LightboxInfoIcon.js.map